import { createFileRoute, redirect } from '@tanstack/react-router';

// The sidebar's Prospect & Enrich section opens on Find People (/finder).
// People type the section as a path (/prospect), so send them there instead of
// to Page not found.
export const Route = createFileRoute('/prospect')({
  beforeLoad: ({ location }) => {
    throw redirect({ to: '/finder', search: location.search, replace: true });
  },
});
